<template>
    <div style="position: relative">
        <d-site
            v-model  = "unit.show"
            :site-id = "unit.id"
        />

        <c-card-iterator
            header-color   = "secondary"
            :title-border   = "true"
            :items          = "filteredItems"
            :label          = "title"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "76"
            :min-height     = "topHeight"
            :filter         = "match"
            :filter-height  = "72"
            :height         = "height"
            @search         = "onSearch"
        >
            <template v-slot:card="{ item }">
                <p-lgs-card
                    :event = "item"
                    @unit = "onUnit"
                />
            </template>
        </c-card-iterator>
        <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
            <v-icon color="success" size="30">mdi-check-circle</v-icon>
        </div>
    </div>
</template>

<script>

import DSite from "@/modules/msd/unit/components/dialog/DSite.vue";
import Core                     from "@/modules/core/service/Core";
import Lgs                     from "@/modules/lgs/events/service/Lgs";
import CCardIterator            from "@/modules/core/components/utils/CCardIterator.vue";
import IncTodoCardIteratorMixin from "@/modules/inc/todos/components/mixins/IncTodoCardIteratorMixin";
import PLgsCard from "@/modules/lgs/events/components/private/PLgsCard.vue";
import Site from "@/modules/msd/unit/service/Site";

export default {
    name: "PLgsIterator",

    props: {
        eventType: {

        },
    },

    components: {
        DSite,
        PLgsCard,
        CCardIterator
    },

    mixins: [
        IncTodoCardIteratorMixin
    ],

    data: () => ({
        unit: {
            show: false,
            id  : null,
        }
    }),

    computed: {
        title () {
            return this.$t("todo.lgs.title") + " - " + this.$t("todo.lgs." + this.eventType + ".title");
        }
    },

    mounted () {
        this.initialize();
    },

    methods: {
        initialize () {
            this.load ();
        },

        load () {
            this.loading = true;

            Lgs.events(this.eventType, this.customer, this.all).then (data => {
                this.items = data;
                this.doFilter();
                this.loading = false;
            });
        },

        // Overrides IncTodoCardIteratorMixin's match/matchDetails, which assume the Inc-shaped
        // item (customerName, liftmanagement, typeName, ...) - the new SiteByStatusResponse items
        // have a different shape and no liftmanagement field at all (see the migration plan: the
        // "nur Anlagen im Liftmanagement" filter is intentionally not honored for these tiles).
        // Server-side scoping already applied customer/allCustomers via Lgs.events() above, so
        // there's no customer re-check needed here, only the free-text search.
        match (item) {
            if (!this.search) {
                return true;
            }

            return Core.filter.includes(item.elevatorNo, this.search) ||
                Core.filter.includes(item.location.street, this.search) ||
                Core.filter.includes(item.location.city, this.search) ||
                Core.filter.includes(item.customer.name, this.search);
        },

        onUnit (event) {
            Site.goto(this, event.siteId);

         //   this.unit.id = event.id;
         //   this.unit.show = true;
            /*
            let url = main.url.dashboard();
            const dashboardId = event.id;
            console.log(url)
            window.open(url + dashboardId, "_blank");

             */
        },
    }
}
</script>

<style scoped>

</style>